<!-- BETA-CLEANUP: delete this file and its spec once Vue 3 is the only app -->
<template>
  <v-tooltip v-if="mini" location="right">
    <template #activator="{ props: activatorProps }">
      <v-list-item
        class="user-actions-list-item"
        aria-label="Try the new version"
        data-test="sidebar-open-beta"
        data-track="beta.sidebar.open"
        v-bind="activatorProps"
        :disabled="isOpeningBeta"
        @click="open"
      >
        <template #prepend>
          <v-progress-circular
            v-if="isOpeningBeta"
            indeterminate
            size="20"
            width="2"
            color="primary"
          />
          <BetaRocketIcon v-else class="text-primary" />
        </template>
      </v-list-item>
    </template>
    <span>Try the new version</span>
    <template v-if="releaseNote">
      <br>
      <span class="text-caption" data-test="sidebar-beta-release">{{ releaseNote }}</span>
    </template>
  </v-tooltip>
  <div v-else class="px-2 pt-2 text-center">
    <v-btn
      color="primary"
      variant="flat"
      block
      :loading="isOpeningBeta"
      data-test="sidebar-open-beta"
      data-track="beta.sidebar.open"
      @click="open"
    >
      <BetaRocketIcon :size="16" class="mr-2" />
      Try the new version
    </v-btn>
    <div v-if="releaseNote" class="text-caption text-medium-emphasis mt-1" data-test="sidebar-beta-release">
      {{ releaseNote }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { getBetaReleaseNote, openBeta } from '@/bundles/App/helpers/betaChannel';

import BetaRocketIcon from '@/bundles/App/components/BetaRocketIcon.vue';

interface IProps {
  // the collapsed rail has room for an icon only
  mini?: boolean;
}

withDefaults(defineProps<IProps>(), {
  mini: false,
});

const releaseNote = getBetaReleaseNote();
const isOpeningBeta = ref(false);

const open = async (): Promise<void> => {
  isOpeningBeta.value = true;

  try {
    await openBeta();
  } finally {
    isOpeningBeta.value = false;
  }
};
</script>
